<template>
  <div role="contentinfo">
    <md-card elevation="5">
      <div v-if="$store.state.electionEvent" class="st">
        <span
          v-if="
            $store.state.electionEvent.HelpDeskInformation &&
              $store.state.electionEvent.HelpDeskInformation
                .ContactInformation &&
              ($store.state.electionEvent.HelpDeskInformation
                .ContactInformation['e-mailAddress'] ||
                $store.state.electionEvent.HelpDeskInformation
                  .ContactInformation.PhoneNumber ||
                $store.state.electionEvent.HelpDeskInformation
                  .ContactInformation.URL ||
                ($store.state.electionEvent.HelpDeskInformation.Description &&
                  $store.state.electionEvent.HelpDeskInformation.Description
                    .Message))
          "
        >
          {{ $t("footer.contacts") }}
          <br aria-hidden="true" /><br />
          <span
            v-if="
              $store.state.electionEvent.HelpDeskInformation.ContactInformation[
                'e-mailAddress'
              ]
            "
            class="contacts"
          >
            {{ $t("footer.e-mail") }}:
            <span class="screenreader">
              {{
                $store.state.electionEvent.HelpDeskInformation.ContactInformation[
                  "e-mailAddress"
                ].replace(/-/g, "trattino")
              }}
            </span>
            <strong aria-hidden="true"
              >{{
                $store.state.electionEvent.HelpDeskInformation
                  .ContactInformation["e-mailAddress"]
              }}
            </strong>
          </span>
          <span
            v-if="
              $store.state.electionEvent.HelpDeskInformation.ContactInformation
                .PhoneNumber
            "
            class="contacts telephone"
          >
            {{ $t("footer.telephone") }}:
            <strong>{{
              $store.state.electionEvent.HelpDeskInformation.ContactInformation
                .PhoneNumber[0]
            }}</strong>
            <br aria-hidden="true" />
          </span>
        </span>
        <span
          v-if="
            $store.state.electionEvent.HelpDeskInformation &&
              $store.state.electionEvent.HelpDeskInformation.Description &&
              $store.state.electionEvent.HelpDeskInformation.Description.Message
          "
          class="description"
        >
          {{
            $store.state.electionEvent.HelpDeskInformation.Description
              .Message[0].content[0]
          }}
          <br aria-hidden="true"
        /></span>
        <br
          v-if="
            !$store.state.electionEvent.HelpDeskInformation.ContactInformation
              .URL
          "
        />
        <span
          v-if="
            $store.state.electionEvent.HelpDeskInformation.ContactInformation
              .URL
          "
          >{{ $t("footer.contact-problems") }}
          <a
            class="acc-link"
            :href="
              $store.state.electionEvent.HelpDeskInformation.ContactInformation
                .URL
            "
          >
            {{ $t("footer.support") }}
          </a></span
        >
        <br />
        <br />
        <Accesibility></Accesibility>

        <p aria-hidden="true"><br /></p>
      </div>
      <div
        id="cookie-container"
        class="cookie-container"
        v-if="$store.state.electionEvent && cookieBanner"
      >
        <div>
          <h2 class="cookie-title">{{ $t("footer.cookie.title") }}</h2>
        </div>
        <p class="text-align">
          {{ $t("footer.cookie.p")
          }}<span
            v-if="
              $store.state.electionEvent != null &&
                $store.state.electionEvent.cookieLink1 != null
            "
            >,
            <a
              :href="$store.state.electionEvent.cookieLink1"
              class="acc-link"
              target="_blank"
              rel="noopener noreferrer"
              >{{ $t("footer.cookie.here-link") }}</a
            ></span
          >{{ $t("footer.cookie.p2")
          }}<span
            v-if="
              $store.state.electionEvent != null &&
                $store.state.electionEvent.cookieLink2 != null
            "
            >,
            <a
              :href="$store.state.electionEvent.cookieLink2"
              class="acc-link"
              target="_blank"
              rel="noopener noreferrer"
              >{{ $t("footer.cookie.here-link") }}</a
            ></span
          >.
        </p>
        <div class="button-container">
          <div></div>
          <div class="right">
            <md-button
              aria-label="Ok"
              class="cookie-ok-button"
              @click="cookieOk()"
            >
              <md-tooltip
                v-bind:style="isMobile ? 'display: none;' : ''"
                class="tooltip"
                style="z-index: 30"
                >{{ $t("footer.cookie.ok-button") }}
              </md-tooltip>
              {{ $t("footer.cookie.ok-button") }}</md-button
            >
          </div>
        </div>
      </div>
    </md-card>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import Utils from "../utils/Utils.js";
import Accesibility from "./Accesibility";

export default {
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();

    this.cookieContainer = document.querySelector(".cookie-container");
    //setTimeout(() => {
    if (this.getCookie("COOKIE_BANNER_OK")) {
      this.cookieBanner = false;
      //this.getCookie("COOKIE_BANNER_OK")
      /* document
          .getElementById("cookie-container")
          .setAttribute("aria-hidden", "true");
        document.getElementById("cookie-container").style.display = "none"; */
    }
    /* }),
      3000; */
  },
  data: function() {
    return {
      isMobile: false,
      openAccessibility: false,
      utils: null,
      cookieContainer: null,
      cookieBanner: true
    };
  },
  props: [],
  methods: {
    openAccess() {
      this.openAccessibility = true;
    },
    closeAccess() {
      this.openAccessibility = false;
    },
    noScroll() {
      document.documentElement.style.overflow = "hidden";
      document.getElementById("app").setAttribute("aria-hidden", "true");
      document
        .getElementById("app")
        .querySelectorAll("input,button,a")
        .forEach(x => (x.tabIndex = "-1"));
      document.getElementById("logout").tabIndex = "-1";
      this.lastFocus = document.activeElement;
    },
    scroll() {
      document.documentElement.style.overflow = "auto";
      document.getElementById("app").setAttribute("aria-hidden", "false");
      document
        .getElementById("app")
        .querySelectorAll("input,button,a")
        .forEach(x => x.removeAttribute("tabindex"));
      document.getElementById("logout").removeAttribute("tabindex");

      this.lastFocus.focus();
    },
    cookieOk() {
      /* var expires = "";
      var date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString(); */
      document.cookie =
        "COOKIE_BANNER_OK=true" + /* expires + */ "; path=/; Secure";

      document
        .getElementById("cookie-container")
        .setAttribute("aria-hidden", "true");
      document.getElementById("cookie-container").style.display = "none";
    },
    getCookie(name) {
      let cookie = {};
      document.cookie.split(";").forEach(function(el) {
        let [k, v] = el.split("=");
        cookie[k.trim()] = v;
      });

      return cookie[name];
    }
    /* Non utilizzato
    clearCookie(name) {
      var domain = document.domain;
      var path = "/";
      document.cookie =
        name +
        "=; expires=" +
        +new Date() +
        "; domain=" +
        domain +
        "; path=" +
        path;
    }*/
  },
  computed: {},

  components: {
    Accesibility
  }
};
</script>
<style scoped>
.st {
  background-color: transparent;
  text-align: center;
  padding: 20px;
  margin: 5px;
  max-height: 150px;
}
.md-card {
  box-shadow: none !important;
  background-color: transparent !important;
  border-top: 1px solid #fff !important;
}
.title {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.005em;
  line-height: 26px;
  color: rgb(0, 0, 0);
  text-align: center;
}
.title2 {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 24px;
  color: rgb(0, 0, 0);
  margin: 15px 0px 15px 0px;
  padding: 0px 0px 10px 0px;
}
.content-space {
  padding: 0px 45px 0px 45px !important;
}
.space {
  margin: 10px;
  padding: 0px 15px 10px 15px;
}
.space.bottom {
  margin-bottom: 40px !important;
}
.md-table-head,
.md-table-cell {
  font-size: 14px;
}
.md-ripple {
  margin-right: 20px;
}
.close-button {
  position: absolute;
  top: 5px !important;
  right: -2px !important;
}
.chiudi-button {
  right: 46.5%;
}

.md-dialog.all {
  width: 35% !important;
  height: auto !important;
  max-width: 90% !important;
  max-height: 90% !important;
}

.contacts {
  margin: 0px 2px 0px 2px;
}

.description {
  color: #383838;
}

.cookie-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(178, 175, 175, 0.93);
  box-shadow: 0 -0.05px 4px rgba(21, 27, 31, 0.712);
  padding: 0 32px;
  transition: 400ms;
}

.cookie-container a {
  color: blue;
}

.cookie-title {
  display: flex;
}

.text-align {
  text-align: initial;
}
.cookie-ok-button {
  background-color: #ffffff;
  float: right;
  border: 1px solid var(--pcolor);
  color: var(--pcolor) !important;
  border-radius: var(--br);
}

.cookie-btn {
  display: flex;
  justify-content: flex-end;
  background: red;
  border: 0;
  padding: 12px 48px;
  font-size: 18px;
  margin-bottom: 16px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 0 1px 1px rgb(151, 217, 248);
}

.button-container {
  display: block;
}

.left {
  float: left;
}

.right {
  float: right;
}

@media screen and (max-width: 504px) {
  .telephone {
    display: block;
  }
}

@media screen and (max-width: 900px) {
  .md-button {
    font-size: 12px !important;
  }
}
@media screen and (max-width: 667px) {
  .all {
    height: 100% !important;
    max-height: 100% !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .md-dialog.all {
    height: 100% !important;
    max-height: 100% !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .md-layout {
    flex: 1;
  }

  .md-button {
    font-size: 14px !important;
  }
}

a.supporto-link:link {
  color: #000000;
  text-decoration: none;
}
a.supporto-link:visited {
  color: #000000;
  text-decoration: none;
}
a.supporto-link:hover {
  color: #000000;
  text-decoration: underline;
}
a.supporto-link:active {
  color: #000000;
  text-decoration: none;
}

a.acc-link:link {
  color: #000000;
  text-decoration: underline;
}
a.acc-link:visited {
  color: #000000;
  text-decoration: none;
}
a.acc-link:hover {
  color: #000000;
  text-decoration: underline;
}
a.acc-link:active {
  color: #000000;
  text-decoration: none;
}
</style>
